import React from 'react';
import { CalendarCard } from './CalendarCard';

export function CalendarPages(){
  return(
    <>
      <CalendarCard/>
    </>
  )
}